import { Drawer, Select } from 'antd'
import React, { useState } from 'react'
import { ReactComponent as DownIcon } from 'assets/icons/down.svg'
import useGetLists from 'hooks/useGetLists'
import { useParams, useHistory } from 'react-router-dom'
import { createOrUpdateEmailCampaign } from 'store/actions/customEmailCampaignActions'
import { ADMIN_EMAIL_CUSTOM_CAMPAIGNS_BUILDER } from 'routes'

const CreateEmailCampaign = ({ onClose, open }) => {
  const history = useHistory()
  const [emailCampaign, setEmailCampaign] = useState({})
  const { lists, isLoading } = useGetLists()
  const { templateId } = useParams()

  const handleSubmit = () => {
    createOrUpdateEmailCampaign({
      ...emailCampaign,
      _id: templateId
    }).then(() => history.push(ADMIN_EMAIL_CUSTOM_CAMPAIGNS_BUILDER))
    onClose()
  }

  return (
    <Drawer closable={false} placement="right" onClose={onClose} open={open}>
      <div className='px-8 py-12'>
        <h1 className='text-2xl font-semibold'>Create an Email Campaign</h1>
        <div className='flex flex-col gap-6 my-10 mb-14'>
          <div className='flex flex-1 flex-col justify-left'>
            <div className='font-bold text-softBlack_70 italic'>Name of your Email Campaign</div>
            <input
              onChange={(e) => setEmailCampaign({
                ...emailCampaign,
                name: e.target.value
              })}
              placeholder='Email Campaign Name'
            />
          </div>
          <div className='flex flex-1 flex-col justify-left '>
            <div className='font-bold text-softBlack_70 italic'>Select Lists</div>
            <Select
              suffixIcon={<DownIcon />}
              showArrow
              onChange={(value) => setEmailCampaign({
                ...emailCampaign,
                list: value
              })}
              placeholder='Select from here'
              className='rating-select text-sm bg-white border border-softBlack30 rounded text-softBlack placeholder-softBlack70 h-10'
            >
              {!isLoading && lists?.map(option => <Select.Option key={option._id} value={option._id}>
                <div className='flex gap-2 items-center'>
                  <span className='h-full'>{option.title}</span>
                </div>
              </Select.Option>)}
            </Select>
          </div>
        </div>
        <div className='flex justify-end gap-2'>
          <button
            className='text-softBlack text-center text-base font-medium py-2 px-6 rounded flex items-center border border-black'
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className='text-softBlack text-center text-base font-medium py-2 px-6 rounded flex items-center bg-volt'
            onClick={handleSubmit}
          >
            Create
          </button>
        </div>
      </div>
    </Drawer>
  )
}

export default CreateEmailCampaign
